import React from 'react';
import { Link, Outlet, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';

const DASHBOARD_BACK_ROUTES = new Set([
  '/appointments',
  '/encounter',
  '/orders',
  '/payment',
  '/profile',
  '/refills',
  '/schedule',
]);

function Layout() {
  const { pathname } = useLocation();
  const showDashboardBack = DASHBOARD_BACK_ROUTES.has(pathname);

  return (
    <div className="flex flex-col h-full w-full bg-highlight min-h-[calc(100vh-4rem)] p-0  md:p-4">
      {showDashboardBack && (
        <div className="w-full max-w-6xl mx-auto px-1 md:px-0 mb-2">
          <Link
            to="/dashboard"
            className="inline-flex items-center py-2 text-sm text-primary-light hover:underline"
          >
            <FontAwesomeIcon icon={faArrowLeft} className="mr-2 ml-0" aria-hidden="true" />
            Back to Dashboard
          </Link>
        </div>
      )}

      {/* Main Content Area */}
      <div id="mainContent" className="flex flex-grow flex-col w-full max-w-6xl mx-auto bg-white rounded-lg  shadow p-1 md:p-6 ">
        {/* Child routes will render here */}
        <Outlet />
      </div>
    </div>
  );
}

export default Layout;

